import { OnInit, Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { GtmService } from '@fcom/common/gtm';
import { ElementActions, ElementTypes, GaContext } from '@fcom/common/interfaces';
import { FragmentService } from '@fcom/common/services';
import { CmsArticle } from '@fcom/core-api';

@Component({
  selector: 'fin-sustainability-review-card',
  templateUrl: 'sustainability-review-card.component.html',
  styleUrls: ['sustainability-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SustainabilityReviewCardComponent implements OnInit {
  private fragmentService = inject(FragmentService);
  private gtmService = inject(GtmService);

  readonly SvgLibraryIcon = SvgLibraryIcon;

  towardsSustainabilityMessage$: Observable<CmsArticle>;

  @Input()
  headerClass = 'font-heading-3 font-title-small';

  @Input()
  showHeader = true;

  @Input()
  isLinkExternal = false;

  ngOnInit(): void {
    this.towardsSustainabilityMessage$ = this.fragmentService.getFragment<CmsArticle>(
      'fragments.towardsSustainability.url'
    );
  }

  trackReadAboutSustainability(): void {
    this.gtmService.trackElement(
      'booking-confirmed-read-more-about-sustainability',
      GaContext.BOOKING_FLOW,
      ElementTypes.LINK,
      undefined,
      ElementActions.CLICK
    );
  }
}
